export const valoresExibidosOffCanvasGlossario: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorEspecifico1: '',
  separadorObservacoes: '',

  //Específicos
  tipoTermo: 'Tipo de Termo',
  nomeTermo: 'Termo Técnico',
  descricao: 'Descrição',
  sinonimos: 'Sinônimos',
  afeicoes: 'Afeições',
  maisInformacoes: 'Mais informações',
};

export const headersGlossario = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 4, key: 'id' },
  { text: 'Tipo de Termo', width: 15, key: 'id' },
  { text: 'Termo Técnico', width: 70, key: 'nomeTermo' },
];

export const fieldObjectGlossario = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
